function setProductConfigValues(d, e, f, g, h, a, b, c) {
    //adding this var to avoid sonar issues popping up
    var productConfig = window.productConfig;
    productConfig.website = e;
    productConfig.gpn = d;
    productConfig.site = f;
    productConfig.applicationProdFolder = g;
    productConfig.anchorlink = h;
    productConfig.headername = a;
    productConfig.lidfolder = b;
    productConfig.lidSite = c
}
$(document).ready(function() {
	var productConfig = window.productConfig;
    var d = "";
    var e = {
        _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
        encode: function(i) {
            var a = "";
            var r, t, o, u, s, b, c;
            var n = 0;
            i = e._utf8_encode(i);
            while (n < i.length) {
                r = i.charCodeAt(n++);
                t = i.charCodeAt(n++);
                o = i.charCodeAt(n++);
                u = r >> 2;
                s = (r & 3) << 4 | t >> 4;
                b = (t & 15) << 2 | o >> 6;
                c = o & 63;
                if (isNaN(t)) {
                    b = c = 64
                } else {
                    if (isNaN(o)) {
                        c = 64
                    }
                }
                a = a + this._keyStr.charAt(u) + this._keyStr.charAt(s) + this._keyStr.charAt(b) + this._keyStr.charAt(c)
            }
            return a
        },
        decode: function(i) {
            var a = "";
            var r, t, o;
            var u, s, b, c;
            var n = 0;
            i = i.replace(/[^A-Za-z0-9\+\/\=]/g, "");
            while (n < i.length) {
                u = this._keyStr.indexOf(i.charAt(n++));
                s = this._keyStr.indexOf(i.charAt(n++));
                b = this._keyStr.indexOf(i.charAt(n++));
                c = this._keyStr.indexOf(i.charAt(n++));
                r = u << 2 | s >> 4;
                t = (s & 15) << 4 | b >> 2;
                o = (b & 3) << 6 | c;
                a = a + String.fromCharCode(r);
                if (b != 64) {
                    a = a + String.fromCharCode(t)
                }
                if (c != 64) {
                    a = a + String.fromCharCode(o)
                }
            }
            a = e._utf8_decode(a);
            return a
        },
        _utf8_encode: function(b) {
            b = b.replace(/\r\n/g, "\n");
            var i = "";
            for (var a = 0; a < b.length; a++) {
                var c = b.charCodeAt(a);
                if (c < 128) {
                    i += String.fromCharCode(c)
                } else {
                    if (c > 127 && c < 2048) {
                        i += String.fromCharCode(c >> 6 | 192);
                        i += String.fromCharCode(c & 63 | 128)
                    } else {
                        i += String.fromCharCode(c >> 12 | 224);
                        i += String.fromCharCode(c >> 6 & 63 | 128);
                        i += String.fromCharCode(c & 63 | 128)
                    }
                }
            }
            return i
        },
        _utf8_decode: function(b) {
            var i = "";
            var a = 0;
            var c, c2;
            while (a < b.length) {
                c = b.charCodeAt(a);
                if (c < 128) {
                    i += String.fromCharCode(c);
                    a++
                } else {
                    if (c > 191 && c < 224) {
                        c2 = b.charCodeAt(a + 1);
                        i += String.fromCharCode((c & 31) << 6 | c2 & 63);
                        a += 2
                    } else {
                        c2 = b.charCodeAt(a + 1);
                        c3 = b.charCodeAt(a + 2);
                        i += String.fromCharCode((c & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                        a += 3
                    }
                }
            }
            return i
        }
    };
    if (window.btoa) {
        var d = btoa("cp33rp")
    } else {
        d = e.encode("cp33rp")
    }
    $.ajax({
        cache: false,
        type: "GET",
        async: false,
        url: "http://" + window.location.host + "/wsapi/" + productConfig.website + "/companionparts/gpn/" + productConfig.gpn + "?output=JSON",
        contentType: "application/json;",
        dataType: "json",
        headers: {
            Authorization: "Basic " + d
        },
        success: function(a) {
            companionProductsTable(a);
            if (a != null) {}
        },
        error: function(a) {}
    })
});

function companionProductsTable(v) {
    //adding this var to avoid sonar issues popping up
    var ProductsTable = window.ProductsTable;
	var productConfig = window.productConfig;
    if (v != null) {
        var J = "";
        var D = "";
        var B;
        var G = $.parseJSON(JSON.stringify(v));
        var N = ProductsTable.tableheader;
        N = N.replace("[[related_header]]", productConfig.headername);
        var w = ProductsTable.tableend;
        var u = N + ProductsTable.tableheaders;
        if (productConfig.website == "en") {
            u = N + ProductsTable.tableheaders
        } else {
            if (productConfig.website == "cn") {
                u = N + ProductsTable.tableheaders_cn
            } else {
                if (productConfig.website == "jp") {
                    u = N + ProductsTable.tableheaders_jp
                }
            }
        }
        var y = "";
        var F = "";
        var E = "";
        var C = "";
        var I = "";
        for (var H = 0; H < G.list.length; H++) {
            var x = G.list[H];
            J = ProductsTable.description.replace("[[description]]", x.d);
            if (x.r == null) {
		B = ProductsTable.metrics_recommendation.replace("[[part1]]", productConfig.gpn).replace("[[part2]]", x.pn);
                var K = "";
                if (x.t != null && x.t == "GPN") {
                    if (productConfig.website == "en") {
                        K = ProductsTable.recommendation_gpn.replace("[[part1]]", productConfig.gpn).replace("[[type]]", "product").replace("[[gpn]]", x.pn).replace("[[part2]]", x.pn).replace(/\[\[folder\]\]/g, productConfig.lidfolder).replace(/\[\[site\]\]/g, productConfig.lidSite).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B)
                    } else {
                        if (productConfig.website == "cn") {
                            K = ProductsTable.recommendation_gpn_cn.replace("[[part1]]", productConfig.gpn).replace("[[type]]", "product/cn").replace("[[gpn]]", x.pn).replace("[[part2]]", x.pn).replace(/\[\[folder\]\]/g, productConfig.lidfolder).replace(/\[\[site\]\]/g, productConfig.lidSite).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B)
                        } else {
                            if (productConfig.website == "jp") {
                                K = ProductsTable.recommendation_gpn_jp.replace("[[part1]]", productConfig.gpn).replace("[[type]]", "product/jp").replace("[[gpn]]", x.pn).replace("[[part2]]", x.pn).replace(/\[\[folder\]\]/g, productConfig.lidfolder).replace(/\[\[site\]\]/g, productConfig.lidSite).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B)
                            } else {
                                K = ProductsTable.recommendation_gpn.replace("[[part1]]", productConfig.gpn).replace("[[type]]", "product").replace("[[gpn]]", x.pn).replace("[[part2]]", x.pn).replace(/\[\[folder\]\]/g, productConfig.lidfolder).replace(/\[\[site\]\]/g, productConfig.lidSite).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B)
                            }
                        }
                    }
                } else {
                    if (x.t != null && x.t == "TPN") {
                        if (productConfig.website == "en") {
                            K = ProductsTable.recommendation_tpn.replace("[[part1]]", productConfig.gpn).replace("[[type]]", "tool").replace("[[gpn]]", x.pn).replace("[[part2]]", x.pn).replace(/\[\[folder\]\]/g, productConfig.lidfolder).replace(/\[\[site\]\]/g, productConfig.lidSite).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B)
                        } else {
                            if (productConfig.website == "cn") {
                                K = ProductsTable.recommendation_tpn_cn.replace("[[part1]]", productConfig.gpn).replace("[[type]]", "tool/cn").replace("[[gpn]]", x.pn).replace("[[part2]]", x.pn).replace(/\[\[folder\]\]/g, productConfig.lidfolder).replace(/\[\[site\]\]/g, productConfig.lidSite).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B)
                            } else {
                                if (productConfig.website == "jp") {
                                    K = ProductsTable.recommendation_tpn_jp.replace("[[part1]]", productConfig.gpn).replace("[[type]]", "tool/jp").replace("[[gpn]]", x.pn).replace("[[part2]]", x.pn).replace(/\[\[folder\]\]/g, productConfig.lidfolder).replace(/\[\[site\]\]/g, productConfig.lidSite).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B)
                                } else {
                                    K = ProductsTable.recommendation_tpn.replace("[[part1]]", productConfig.gpn).replace("[[type]]", "tool").replace("[[gpn]]", x.pn).replace("[[part2]]", x.pn).replace(/\[\[folder\]\]/g, productConfig.lidfolder).replace(/\[\[site\]\]/g, productConfig.lidSite).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B)
                                }
                            }
                        }
                    }
                }
                B = ProductsTable.metrics_recommendation.replace("[[part1]]", productConfig.gpn).replace("[[part2]]", x.pn);
                D = ProductsTable.whyRecommended.replace("[[recommendation]]", K)
            } else {
                if (x.r != null && x.r.length > "160") {
                    B = x.r;
                    var M = x.r.substr(160, x.r.length).indexOf(" ");
                    var z = x.r.substr(0, 160 + M);
                    var A = x.r.substr(160 + M, x.r.length);
                    D = ProductsTable.recommendation_div.replace("[[recommendation1]]", z).replace("[[recommendation2]]", A).replace(/\[\[idx\]\]/g, H)
                } else {
                    B = x.r;
                    D = ProductsTable.whyRecommended.replace("[[recommendation]]", x.r)
                }
            }
            if (x.t != null && x.t == "GPN") {
                if (productConfig.website == "en") {
                    y = ProductsTable.partNumber.replace("[[type]]", "product").replace("[[gpn]]", x.pn).replace("[[partName]]", x.pn).replace(/\[\[folder\]\]/g, productConfig.lidfolder).replace(/\[\[site\]\]/g, productConfig.lidSite).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B)
                } else {
                    if (productConfig.website == "cn") {
                        y = ProductsTable.partNumber_cn.replace("[[type]]", "product").replace("[[gpn]]", x.pn).replace("[[partName]]", x.pn).replace(/\[\[folder\]\]/g, productConfig.lidfolder).replace(/\[\[site\]\]/g, productConfig.lidSite).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B)
                    } else {
                        if (productConfig.website == "jp") {
                            y = ProductsTable.partNumber_jp.replace("[[type]]", "product").replace("[[gpn]]", x.pn).replace("[[partName]]", x.pn).replace(/\[\[folder\]\]/g, productConfig.lidfolder).replace(/\[\[site\]\]/g, productConfig.lidSite).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B)
                        } else {
                            y = ProductsTable.partNumber.replace("[[type]]", "product").replace("[[gpn]]", x.pn).replace("[[partName]]", x.pn).replace(/\[\[folder\]\]/g, productConfig.lidfolder).replace(/\[\[site\]\]/g, productConfig.lidSite).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B)
                        }
                    }
                }
            } else {
                if (x.t != null && x.t == "TPN") {
                    if (productConfig.website == "en") {
                        y = ProductsTable.partNumber_tpn.replace("[[type]]", "tool").replace("[[gpn]]", x.pn).replace("[[partName]]", x.pn).replace(/\[\[folder\]\]/g, productConfig.lidfolder).replace(/\[\[site\]\]/g, productConfig.lidSite).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B)
                    } else {
                        if (productConfig.website == "cn") {
                            y = ProductsTable.partNumber_cn_tpn.replace("[[type]]", "tool").replace("[[gpn]]", x.pn).replace("[[partName]]", x.pn).replace(/\[\[folder\]\]/g, productConfig.lidfolder).replace(/\[\[site\]\]/g, productConfig.lidSite).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B)
                        } else {
                            if (productConfig.website == "jp") {
                                y = ProductsTable.partNumber_jp_tpn.replace("[[type]]", "tool").replace("[[gpn]]", x.pn).replace("[[partName]]", x.pn).replace(/\[\[folder\]\]/g, productConfig.lidfolder).replace(/\[\[site\]\]/g, productConfig.lidSite).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B)
                            } else {
                                y = ProductsTable.partNumber_tpn.replace("[[type]]", "tool").replace("[[gpn]]", x.pn).replace("[[partName]]", x.pn).replace(/\[\[folder\]\]/g, productConfig.lidfolder).replace(/\[\[site\]\]/g, productConfig.lidSite).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B)
                            }
                        }
                    }
                } else {
                    y = ProductsTable.delimitorOpen + x.pn + ProductsTable.delimitorClose
                }
            }
            if (x.td != null && x.ts != null) {
                if (productConfig.website == "en") {
                    F = ProductsTable.delimitorOpen + ProductsTable.technicalDocuments.replace("[[URL]]", x.td).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite);
                    E = ProductsTable.toolsSoftware.replace("[[URL]]", x.ts).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.delimitorClose
                } else {
                    if (productConfig.website == "cn") {
                        F = ProductsTable.delimitorOpen + ProductsTable.technicalDocuments_cn.replace("[[URL]]", x.td).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite);
                        E = ProductsTable.toolsSoftware_cn.replace("[[URL]]", x.ts).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.delimitorClose
                    } else {
                        if (productConfig.website == "jp") {
                            F = ProductsTable.delimitorOpen + ProductsTable.technicalDocuments_jp.replace("[[URL]]", x.td).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite);
                            E = ProductsTable.toolsSoftware_jp.replace("[[URL]]", x.ts).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.delimitorClose
                        } else {
                            F = ProductsTable.delimitorOpen + ProductsTable.technicalDocuments.replace("[[URL]]", x.td).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite);
                            E = ProductsTable.toolsSoftware.replace("[[URL]]", x.ts).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.delimitorClose
                        }
                    }
                }
            }
            if (x.td != null && x.ts == null) {
                E = "";
                if (productConfig.website == "en") {
                    F = ProductsTable.delimitorOpen + ProductsTable.technicalDocuments.replace("[[URL]]", x.td).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.delimitorClose
                } else {
                    if (productConfig.website == "cn") {
                        F = ProductsTable.delimitorOpen + ProductsTable.technicalDocuments_cn.replace("[[URL]]", x.td).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.delimitorClose
                    } else {
                        if (productConfig.website == "jp") {
                            F = ProductsTable.delimitorOpen + ProductsTable.technicalDocuments_jp.replace("[[URL]]", x.td).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.delimitorClose
                        } else {
                            F = ProductsTable.delimitorOpen + ProductsTable.technicalDocuments.replace("[[URL]]", x.td).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.delimitorClose
                        }
                    }
                }
            }
            if (x.td == null && x.ts != null) {
                F = "";
                if (productConfig.website == "en") {
                    E = ProductsTable.delimitorOpen + ProductsTable.toolsSoftware.replace("[[URL]]", x.ts).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.delimitorClose
                } else {
                    if (productConfig.website == "cn") {
                        E = ProductsTable.delimitorOpen + ProductsTable.toolsSoftware_cn.replace("[[URL]]", x.ts).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.delimitorClose
                    } else {
                        if (productConfig.website == "jp") {
                            E = ProductsTable.delimitorOpen + ProductsTable.toolsSoftware_jp.replace("[[URL]]", x.ts).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.delimitorClose
                        } else {
                            E = ProductsTable.delimitorOpen + ProductsTable.toolsSoftware.replace("[[URL]]", x.ts).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.delimitorClose
                        }
                    }
                }
            }
            if (x.td == null && x.ts == null) {
                E = "";
                F = ProductsTable.delimitorOpen + "--" + ProductsTable.delimitorClose
            }
            if (x.ds == null && x.od == null) {
                I = "";
                C = ProductsTable.delimitorOpen + "--" + ProductsTable.delimitorClose;
                if (x.t == "TPN") {
                    E = "";
                    if (productConfig.website == "en") {
                        F = ProductsTable.delimitorOpen + ProductsTable.technicalDocuments_tpn.replace("[[gpn]]", x.pn).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.delimitorClose
                    } else {
                        if (productConfig.website == "cn") {
                            F = ProductsTable.delimitorOpen + ProductsTable.technicalDocuments_cn_tpn.replace("[[gpn]]", x.pn).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.delimitorClose
                        } else {
                            if (productConfig.website == "jp") {
                                F = ProductsTable.delimitorOpen + ProductsTable.technicalDocuments_jp_tpn.replace("[[gpn]]", x.pn).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.delimitorClose
                            } else {
                                F = ProductsTable.delimitorOpen + ProductsTable.technicalDocuments_tpn.replace("[[gpn]]", x.pn).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.delimitorClose
                            }
                        }
                    }
                }
            }
            if (x.ds == null && x.od != null) {
                I = "";
                if (productConfig.website == "en") {
                    C = ProductsTable.delimitorOpen + ProductsTable.listOpen + ProductsTable.onlineDatasheet.replace("[[URL]]", x.od).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B) + ProductsTable.listClose + ProductsTable.delimitorClose
                } else {
                    if (productConfig.website == "cn") {
                        C = ProductsTable.delimitorOpen + ProductsTable.listOpen + ProductsTable.onlineDatasheet_cn.replace("[[URL]]", x.od).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B) + ProductsTable.listClose + ProductsTable.delimitorClose
                    } else {
                        if (productConfig.website == "jp") {
                            C = ProductsTable.delimitorOpen + ProductsTable.listOpen + ProductsTable.onlineDatasheet_jp.replace("[[URL]]", x.od).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B) + ProductsTable.listClose + ProductsTable.delimitorClose
                        } else {
                            C = ProductsTable.delimitorOpen + ProductsTable.listOpen + ProductsTable.onlineDatasheet.replace("[[URL]]", x.od).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B) + ProductsTable.listClose + ProductsTable.delimitorClose
                        }
                    }
                }
            }
            if (x.ds != null && x.od == null) {
                C = "";
                if (productConfig.website == "en") {
                    I = ProductsTable.delimitorOpen + ProductsTable.listOpen + ProductsTable.pdfDatasheet.replace("[[URL]]", x.ds).replace("[[size]]", x.ls).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.listClose + ProductsTable.delimitorClose
                } else {
                    if (productConfig.website == "cn") {
                        I = ProductsTable.delimitorOpen + ProductsTable.listOpen + ProductsTable.pdfDatasheet_cn.replace("[[URL]]", x.ds).replace("[[size]]", x.ls).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.listClose + ProductsTable.delimitorClose
                    } else {
                        if (productConfig.website == "jp") {
                            I = ProductsTable.delimitorOpen + ProductsTable.listOpen + ProductsTable.pdfDatasheet_jp.replace("[[URL]]", x.ds).replace("[[size]]", x.ls).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.listClose + ProductsTable.delimitorClose
                        } else {
                            I = ProductsTable.delimitorOpen + ProductsTable.listOpen + ProductsTable.pdfDatasheet.replace("[[URL]]", x.ds).replace("[[size]]", x.ls).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.listClose + ProductsTable.delimitorClose
                        }
                    }
                }
            }
            if (x.ds != null && x.od != null) {
                if (productConfig.website == "en") {
                    C = ProductsTable.delimitorOpen + ProductsTable.listOpen + ProductsTable.onlineDatasheet.replace("[[URL]]", x.od).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite);
                    I = ProductsTable.pdfDatasheet.replace("[[URL]]", x.ds).replace("[[size]]", x.ls).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.listClose + ProductsTable.delimitorClose
                } else {
                    if (productConfig.website == "cn") {
                        C = ProductsTable.delimitorOpen + ProductsTable.listOpen + ProductsTable.onlineDatasheet_cn.replace("[[URL]]", x.od).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite);
                        I = ProductsTable.pdfDatasheet_cn.replace("[[URL]]", x.ds).replace("[[size]]", x.ls).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.listClose + ProductsTable.delimitorClose
                    } else {
                        if (productConfig.website == "jp") {
                            C = ProductsTable.delimitorOpen + ProductsTable.listOpen + ProductsTable.onlineDatasheet_jp.replace("[[URL]]", x.od).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite);
                            I = ProductsTable.pdfDatasheet_jp.replace("[[URL]]", x.ds).replace("[[size]]", x.ls).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.listClose + ProductsTable.delimitorClose
                        } else {
                            C = ProductsTable.delimitorOpen + ProductsTable.listOpen + ProductsTable.onlineDatasheet.replace("[[URL]]", x.od).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite);
                            I = ProductsTable.pdfDatasheet.replace("[[URL]]", x.ds).replace("[[size]]", x.ls).replace("[[gpn]]", x.pn).replace("[[u]]", H).replace("[[rType]]", B).replace(/\[\[folder\]\]/g, x.pn).replace(/\[\[site\]\]/g, productConfig.lidSite) + ProductsTable.listClose + ProductsTable.delimitorClose
                        }
                    }
                }
            }
            u = u + y + J + C + I + F + E + D
        }
        u = u + w;
        $("#relProdData").html(u);
        if (G.list == null || G.list.length == 0) {
            $("#relProdData").html("")
        } else {
            var L = "";
            com.TI.Product.handleQuickLinks("relProd", productConfig.anchorlink, "#relProds", L)
        }
    }
    $(function() {
        var a = 5000000;
        $(".collapsible").each(function(c, b) {
            var d = b,
                e = $(b),
                f = e.children(".click");
            if (!e.parent().hasClass("collapsible-set")) {
                f.click(function(g) {
                    e.toggleClass("up");
                    e.children(".collapsed").slideToggle({
                        duration: a
                    })
                })
            } else {
                f.click(function(g) {
                    e.parent().children(".collapsible").each(function(i, h) {
                        if (h == d) {
                            $(h).toggleClass("up");
                            $(h).children(".collapsed").slideToggle({
                                duration: a
                            });
                            if ($(h).hasClass("border-bottom")) {
                                setTimeout(function() {
                                    $("html").animate({
                                        scrollTop: f.offset().top
                                    }, 200)
                                }, 500)
                            }
                        } else {
                            $(h).removeClass("up");
                            $("#click").text("less");
                            $(h).children(".collapsed").slideUp({
                                duration: a
                            })
                        }
                    })
                })
            }
        })
    })
};